import {
    Component,
    ChangeDetectionStrategy,
    ViewChild,
    ChangeDetectorRef,
    ElementRef,
    Renderer2,
    Self,
    Input,
    input,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { BazisConfigurationService } from '@bazis/configuration.service';
import { BazisInputDefaultComponent } from '@bazis/form/components/base/inputs/input-default.component';
import { TemplateObservable } from '@bazis/shared/classes/template-observable';

@Component({
    selector: 'app-search-field-expanded',
    templateUrl: './search-field-expanded.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SearchFieldExpandedComponent extends BazisInputDefaultComponent {
    @Input()
    forceExpanded: boolean = false;

    fillShortButton = input<'clear' | 'outline' | 'solid'>('outline');

    @ViewChild('searchInput') set searchInput(el: ElementRef) {
        if (!el) return;

        this.nativeSearchInput = el.nativeElement;

        // Тонкая настройка: "Смотреть можно, трогать — нет!"
        this.renderer.listen(this.nativeSearchInput, 'focus', (event) => {
            // this.nativeSearchInput.value = this.nativeSearchInput.value;
            // console.log('focus', this.nativeSearchInput.value.length);
            this.nativeSearchInput.selectionStart = this.nativeSearchInput.value.length;
            // console.log('focus', this.nativeSearchInput.value.length, this.nativeSearchInput.selectionStart);
        });
    }

    isExpanded$: TemplateObservable<boolean> = new TemplateObservable(false);

    nativeSearchInput;

    constructor(
        @Self() public ngControl: NgControl,
        protected cdr: ChangeDetectorRef,
        public configurationService: BazisConfigurationService,
        private renderer: Renderer2,
    ) {
        super(ngControl, cdr, configurationService);
        ngControl.valueAccessor = this;
    }

    clearAndClose() {
        this.markAsTouched();
        this.field.setValue('');
        if (!this.forceExpanded) {
            this.isExpanded$.set(false);
        }
    }

    blurField(e) {
        super.blurField(e);
        if (!this.ngControl.control.value && !this.forceExpanded) {
            this.isExpanded$.set(false);
        }
    }

    expandedField() {
        if (!this.forceExpanded) {
            this.isExpanded$.set(true);
        }
        // ждем когда распахнется поле и ставим в него фокус
        setTimeout(() => {
            if (this.nativeSearchInput) {
                this.nativeSearchInput.focus();
            }
        }, 100);
    }
}
